module.exports = __webpack_public_path__ + "static/media/ttc-logo-icon.555d61c4.svg";